<template>
  <div class="detail_content">
    <div class="detail_label">
      {{ titleLabel }}
      <div v-if="!notRequiredFlag" class="require_items_label">
        {{ requiredItemLabel }}
      </div>
    </div>
    <datepicker
      :placeholder="placeholderValue"
      :config="config"
      id="cnstract_date"
      @on-change="customFormatter"
      :locale="ja"
      :value="value"
      class="start_datepicker"
    >
    </datepicker>
  </div>
</template>

<script>
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  props: {
    titleLabel: String,
    notRequiredFlag: Boolean,
    placeholderValue: String
  },
  data() {
    return {
      ja: japanese,
      config: {
        dateformat: 'YYYY/mm/DD',
        locale: japanese,
        maxDate: '9999'
      },
      value: ''
    }
  },
  computed: {
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  components: {
    datepicker
  },
  methods: {
    customFormatter(e) {
      let date = new Date(e)
      if (!Number.isNaN(date.getTime())) {
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var day = date.getDate()
        event.target.value = year + '/' + month + '/' + day
      } else {
        if (this.placeholderValue !== 'Select Date') {
          event.target.value = this.placeholderValue
        } else {
          event.target.value = ''
        }
      }
      this.$emit('inputUpdate', event.target.value)
    }
  }
}
</script>
<style scoped>
.start_datepicker {
  width: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/datepickerSection.vue